import React, { Fragment, useState, useEffect } from 'react'

const DashboardScan = () => {
  return <Fragment>Hello</Fragment>
}
export default DashboardScan
